



























import { Component, Vue, Prop } from "vue-property-decorator";
import CountDown from "@/components/countDown/CountDown.vue";
@Component({
  components: {
    CountDown
  }
})
export default class LimitStatus extends Vue {
  @Prop({ default: "" })
  private limitedCountNum?: number;
  private countDownNum: number = 0; // second
}
